import React from 'react';
import { InnerRouter } from '../../../components/AnimatedRouter';
import ProgressBar from '../../../components/ProgressBar';

enum STEP {
  'set-code',
  'account',
  'golf-info',
  'complete'
}

const Register = ({ children, location }: { children: any; location: any }) => {
  const route = location.pathname.split('/')[2];
  return (
    <div className="register">
      <div className="wrapper header-wrapper">
        <div className="top">
          <ProgressBar step={Number(STEP[route]) || 0} variant="player" />
        </div>
      </div>
      <div
        className={`wrapper ${route === 'complete' ? 'wrapper--no-padding : ' : ''}`}
      >
        <InnerRouter className="slow" location={location}>
          {children}
        </InnerRouter>
      </div>
    </div>
  );
};

export { Register };
